<template>
  <div>
    <div class="page-header">
      <div class="page-leftheader">
        <div class="headline">
          <h4 class="page-title text-primary">Alle Ereignisse</h4>
        </div>
      </div>
      <div class="page-rightheader">
        <a
          class="btn btn-primary btn-pill mr-1"
          @click="openEditEvent(editEvent, 'new')"
          >Veranstaltung hinzufügen</a
        >
        <a class="btn btn-primary btn-pill" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i class="fa fa-calendar me-2 fs-14"></i> Nach Datum filtern</a>
        <div class="dropdown-menu border-0">
                <a class="dropdown-item" id="dropdownToday" @click="setTimePicker('Today')">Letzte 24 Stunden</a>
                <a class="dropdown-item" id="dropdownLastWeek" @click="setTimePicker('LastWeek')">Letzte 7 Tage</a>
                <a class="dropdown-item" id="dropdownLastMonth" @click="setTimePicker('LastMonth')">Letzte 30 Tage</a>
                <a class="dropdown-item active" id="dropdownAllTime" @click="setTimePicker('AllTime')">Gesamt</a>
        </div>
      </div>
    </div>
    <div>
      <div>
        <input
          v-model="search"
          type="search"
          class="form-control form-control-sm"
          placeholder="Suche..."
          aria-controls="example1"
        />
        <br />
      </div>
      <div>
        <!-- Left Area -->
        <div class="card">
          <div class="table-responsive">
            <table class="table card-table table-vcenter text-nowrap">
              <thead>
                <tr>
                  <th>Bild</th>
                  <th>Name</th>
                  <th>Datum</th>
                  <th>Aktionen</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="event in events" :key="event._id">
                  <td class="align-middle">
                    <img
                      :src="`${$img(event.image,$awsLargeImages)}`"
                      alt="img"
                      class="avatar avatar-md brround"
                      @error="handleImageError"
                    />
                  </td>
                  <td class="align-middle">{{ event.title }}</td>
                  <td class="align-middle">
                    {{ $formatDate(event.eventDate) }}
                  </td>
                  <td>
                    <a
                      title="Ereignis bearbeiten"
                      class="btn btn-primary btn-small mr-1"
                      @click="openEditEvent(event, 'edit')"
                      ><i class="fas fa-edit"></i
                    ></a>
                    <a
                      title="Ereignis löschen"
                      class="btn btn-small btn-danger"
                      @click="openDeleteEvent(event)"
                      ><i class="fas fa-trash-alt"></i
                    ></a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div style="position:absolute; bottom: 500px;left:50%;height:40px;width:40px " v-intersect.quiet="infiniteScrolling"></div>
      </div>
    </div>

    <v-dialog v-model="editDialog" width="500">
      <v-card>
          <v-card-title class="card">
            <!-- WAR FALSCH: Der Titel stand fest auf "Ereignis bearbeiten" —
                 auch beim Anlegen einer neuen Veranstaltung über "Veranstaltung
                 hinzufügen". Der Verwalter sah dadurch keinen Unterschied
                 zwischen Anlegen und Bearbeiten und konnte nicht erkennen, in
                 welchem Modus der Dialog gerade ist. -->
            <h4 class="page-title text-primary">{{ editEvent.editType == 'new' ? 'Veranstaltung anlegen' : 'Ereignis bearbeiten' }}</h4>
          </v-card-title>
        <v-card-text>

          <div class="form-group">
            <label class="form-label">Name</label>
            <input
              type="text"
              class="form-control"
              placeholder="Name"
              v-model="editEvent.title"
              v-bind:class="{'is-invalid': emptyValidation && (editEvent.title == null || editEvent.title == '')}"
            />
          </div>

          <div class="form-group">
            <label class="form-label">Beschreibung</label>
            <textarea
              rows="4"
              class="form-control"
              placeholder="Beschreibung"
              v-model="editEvent.description"
              v-bind:class="{'is-invalid': emptyValidation && (editEvent.description == null || editEvent.description == '')}"
            ></textarea>
          </div>

          <div class="form-group">
            <label class="form-label">Datum</label>
            <!-- WAR FALSCH (und inzwischen ZURÜCKGENOMMEN): Hier stand eine
                 Sperre gegen Termine in der Vergangenheit (min-Attribut plus
                 isPastDate() in der Feldprüfung). Grund damals: Ein
                 nachgetragener Termin war anschließend nirgends mehr
                 auffindbar, weil Liste und Suche vergangene Termine
                 ausblendeten. Genau diese Ursache ist seitdem im Server
                 behoben — ein Verwalter bekommt jetzt alle Veranstaltungen,
                 auch vergangene (eventController.js: der Terminfilter gilt
                 nur noch für App-Nutzer). Damit nahm die Sperre dem Verwalter
                 eine Möglichkeit, die das System unterstützt (ein Treffen von
                 letzter Woche nachtragen) — und das mit einer irreführenden
                 Begründung: Die Prüfung färbte nur das Feld rot, und
                 saveEvent() zählt lediglich, WIE VIELE Felder rot sind, nicht
                 warum. Der Verwalter las deshalb "alle erforderlichen Felder
                 ausfüllen", obwohl das Datum ausgefüllt war. -->
            <input
              type="date"
              class="form-control"
              placeholder=""
              v-model="editEvent.eventDateObject"
              v-bind:class="{'is-invalid': emptyValidation && (editEvent.eventDateObject == null || editEvent.eventDateObject == '')}"
            />
          </div>

          <div class="form-group">
            <label class="form-label">Standort</label>
            <GoogleMap v-model="editEvent.eventAddressObject" :validated="emptyValidation && editEvent.eventAddressObject ? true : false"/>
            
          </div>

          <div class="form-group">
            <label class="form-label">Bild</label>
                <div class="card overflow-hidden shadow-none border" v-if="editEvent.editType == 'edit'">
                  <img :src="`${$img(editEvent.image,$awsLargeImages)}`" alt="image" class="card-image1 " @error="handleImageError">
                </div>
                <div class="card overflow-hidden shadow-none border" v-if="updatedPic">
                  <img
                    :src="updatedPic"
                    alt="image"
                    class="img-thumb"
                  />
                </div>
                <div class="input-group file-browser mb-5 mt-4">
                  <input
                    type="text"
                    id="imageFileDisplay"
                    class="form-control browse-file"
                    placeholder=""
                    disabled
                    v-bind:class="{'is-invalid': emptyValidation && checkFileInput() && (editEvent.image == null || editEvent.image == '')}"
                  />
                  <label class="input-group-text btn btn-primary">
                    Durchsuchen
                    <input
                      id="imageFile"
                      type="file"
                      class="file-browserinput"
                      style="display: none"
                      multiple=""
                      accept="image/png, image/jpeg"
                      v-on:change="setFileName"
                    />
                  </label>
                </div>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <a class="btn btn-primary btn-pill mr-1" @click="editDialog=false">Abbrechen</a>
          <a class="btn btn-primary btn-pill" @click="saveEvent()">Speichern</a>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog 
        v-model="deleteDialog"
        width="500">
        <v-card>
         <v-card-title class="card">
            <h4 class="page-title text-primary">Ereignis löschen</h4>
          </v-card-title>
          <v-card-text>
            Sind Sie sicher, dass Sie dieses Ereignis löschen wollen?
          </v-card-text>
                    <v-divider></v-divider>
        <v-card-actions>
            <v-spacer></v-spacer>
              <a class="btn btn-primary btn-pill mr-1" @click="deleteDialog=false">Abbrechen</a>
              <a class="btn btn-danger btn-pill" @click="deleteEvent()">Löschen</a>
          </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="emptyDialog" width="500">
      <v-card>
        <v-card-title class="card">
            <h4 class="page-title text-primary">Fehler</h4>
        </v-card-title>
        <v-spacer></v-spacer>
        <v-card-text>
          Zum Speichern müssen alle erforderlichen Felder ausgefüllt sein.
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
              <a class="btn btn-primary btn-pill" @click="emptyDialog=false">Okay</a>
          </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import GoogleMap from "./widget/GoogleMap.vue";

export default {
  components: {},

  data() {
    return {
      page: 0,
      totalPages: 1,
      ElementPerPage: 25,
      sort: null,
      order: true,
      search: "",
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) =>
          /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "E-mail must be valid",
      ],
      rules: [(value) => !!value || this.$t("required")],
      tenants: [
        {
          name: "",
        },
      ],

      // Personal Data
      me: null,

      events: [],
      editEvent: {},
      updatedPic: '',

      emptyValidation: false,

      editDialog: false,
      deleteDialog: false,
      emptyDialog: false,
      currentTimeSpan: 'AllTime'
    };
  },

  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    search: function () {
      if (this.search == "") {
        this.fetchEvents();
      } else {
        this.page = 0;
        console.log(this.search);
        this.searchEvent();
      }
    },
    editDialog: function () {
       if(this.editDialog == false) {
         this.emptyValidation = false;
         this.$forceUpdate();
       }
    }
  },

  mounted() {
    this.fetchEvents();
    if(this.$route.params.event) {
      this.openEditEvent(this.$route.params.event, 'edit');
    }
    this.$root.$on('Events', (event) => {
      this.openEditEvent(event, 'edit');
    })
  },

  methods: {
    infiniteScrolling(entries, observer, isIntersecting) {
        if(isIntersecting){
            setTimeout(() => {
                var _this = this;
                // WAR FALSCH: Es wurde nur weiter nachgeladen, wenn die letzte
                // Seite GENAU ElementPerPage Einträge lieferte. Die
                // Datenbankabfrage schneidet aber erst die Seite heraus und
                // blendet danach Einträge gesperrter/gelöschter Ersteller aus
                // — eine Seite mit z.B. 20 statt 25 Einträgen bedeutete also
                // nicht zwangsläufig "Ende der Liste". FOLGE: Das Nachladen
                // blieb dauerhaft stehen, obwohl auf den nächsten Seiten noch
                // Veranstaltungen lagen. Jetzt wird weitergeladen, solange die
                // letzte Anfrage überhaupt etwas geliefert hat.
                if(this.lastEvents > 0 || this.lastEvents == null){
                  console.log(this.page);
                  if(this.search ==  "" || this.search == null){
                    this.page++;
                    // Hier stand '/trip/all/' statt '/event/all/': Beim Scrollen
                    // wurden Touren an die Veranstaltungsliste angehängt.
                    // "Bearbeiten" öffnete dann eine Tour und schickte sie an
                    // /event/update.
                    this.$axios
                          .get('/event/all/' + this.page * this.ElementPerPage + '/' + this.ElementPerPage + '/' + this.getCurrentTimeSpan())
                          .then(function (response){
                            _this.lastEvents = response.data.data.length;
                            if(response.data.data.length >= 1) {
                              response.data.data.forEach(item => _this.events.push(item));
                            }
                          })
                          .catch(this.onError);
                  }
                  else{
                    console.log('infinitesearch');
                    this.page++;
                    // Auch hier wurde die Tour-Suche aufgerufen ('/trip/search/'):
                    // Beim Nachladen einer Suche standen plötzlich Touren in der
                    // Veranstaltungsliste. Zusätzlich fehlte encodeURIComponent —
                    // ein Suchbegriff mit "/" oder "?" zerlegte den Pfad und die
                    // Anfrage lief in einen 404.
                    this.$axios.get('/event/search/' + encodeURIComponent(this.search) +'/'+ this.page * this.ElementPerPage + '/' + this.ElementPerPage + '/' + this.getCurrentTimeSpan()).then(function(response){
                      _this.lastEvents = response.data.data.length;
                      if(response.data.data.length >= 1) {
                        response.data.data.forEach(item => _this.events.push(item));
                      }
                    }).catch(function(error){
                      console.error(error);
                    });
                  }
                }
            }, 500);
        }
    },
    fetchEvents() {
      var _this = this;
      // Der Zähler blieb beim Neuladen stehen: Wer vorher gescrollt hatte,
      // sprang beim nächsten Nachladen mitten in die Liste und übersprang alles
      // dazwischen.
      this.page = 0;
      this.$axios
        .get("/event/all/0/" + this.ElementPerPage + '/' + this.getCurrentTimeSpan())
        .then(function (response) {
          _this.events = response.data.data;
          // lastEvents wurde hier nie gesetzt. Nach einer Suche mit wenigen
          // Treffern blieb der alte, kleine Wert stehen und das Nachladen war
          // dauerhaft tot.
          _this.lastEvents = response.data.data.length;
        })
        .catch(function (error) {
          console.error(error);
        });
    },
    searchEvent() {
      var _this = this;
      this.$axios
        .get(
          // Ohne encodeURIComponent zerlegte ein Suchbegriff mit "/" oder "?"
          // den Pfad — die Anfrage traf dann keine Route mehr (404).
          "/event/search/" +
            encodeURIComponent(this.search) +
            "/" +
            this.page +
            "/" +
            this.ElementPerPage
            + '/' + this.getCurrentTimeSpan()
        )
        .then(function (response) {
          _this.events = response.data.data;
          _this.lastEvents = _this.events.length;
        })
        .catch(function (error) {
          console.error(error);
        });
    },
    // Vertauscht die Reihenfolge eines Koordinatenpaars. Gleiche Umsetzung
    // wie swapCoordinates() in Trips.vue.
    swapCoordinates(coordinates) {
      return [coordinates[1], coordinates[0]];
    },
    onError(err) {
      if (err.response != null && err.response.data != null) {
        // this.console gibt es nicht — der Fehlerbehandler warf hier selbst
        // und verdeckte damit die eigentliche Ursache.
        console.error(err.response.data);
      } else {
        console.error(err);
      }
    },
    // Fängt eine kaputte Bildadresse ab (Datei im Bildspeicher gelöscht,
    // Upload nur halb durchgelaufen). Ohne diesen Rückfall zeigte der
    // Browser in jeder betroffenen Tabellenzeile nur das zerbrochene
    // Bildsymbol.
    // WAR FALSCH (zweimal): Zuerst setzte die Bremse "event.target.onerror =
    // null" — das löscht nur die alte HTML-Eigenschaft onerror, die hier nie
    // benutzt wird. Die Vorlage meldet den Rückfall über "@error", Vue
    // registriert das intern per addEventListener; dieser Zuhörer blieb
    // aktiv, setzte bei einem scheiternden Ersatzbild erneut dieselbe
    // Adresse und drehte sich damit endlos im Kreis. Der zweite Anlauf
    // merkte sich den Rückfall dauerhaft am Bild-Element selbst
    // ("data-fallback-used"). Das bremste zwar die Schleife, galt aber für
    // IMMER: Die Tabellenzeilen haben einen festen Schlüssel (:key), Vue
    // verwendet dasselbe Bild-Element über jedes Neuladen der Liste hinweg
    // weiter. Lud der Verwalter danach ein neues, ebenfalls kaputtes Bild
    // hoch, bekam diese Zeile keinen Rückfall mehr und zeigte wieder das
    // zerbrochene Bildsymbol des Browsers. Jetzt wird nicht mehr gemerkt
    // "Rückfall schon einmal benutzt", sondern geprüft, ob die AKTUELLE
    // Adresse bereits das Ersatzbild ist — das bremst genau die echte
    // Schleife (das Ersatzbild scheitert selbst) und lässt jedes neue Bild
    // wieder zu.
    handleImageError(event) {
      const fallbackImage = '/images/brand/favicon.png';
      if (event.target.getAttribute('src') === fallbackImage) return;
      event.target.src = fallbackImage;
    },
    openEditEvent(event, type) {
      this.initializeEvent();
      this.updatedPic = '';
      if(type == "edit") {
        // Hier stand `this.editEvent = event;` — damit flog das eben in
        // initializeEvent() aufgebaute Objekt weg und wurde durch den rohen
        // Datensatz vom Server ersetzt. Der kennt weder `eventAddressObject`
        // noch `eventDateObject` noch `editType`; sie wurden erst danach
        // angehängt und waren deshalb in Vue 2 nicht beobachtbar.
        //
        // FOLGE: Die Karte schreibt über `v-model="editEvent.eventAddressObject"`
        // in genau dieses Feld zurück (GoogleMap.vue). Wer eine Adresse
        // auswählte, sah sie im Formular nicht erscheinen — erst wenn ein
        // anderes Feld die Ansicht neu aufbaute.
        //
        // Jetzt werden die Serverdaten in das vorbereitete Objekt gelegt,
        // statt es zu ersetzen. Alle Felder bleiben beobachtbar.
        // Eine Kopie, damit das Tippen im Dialog nicht die Tabellenzeile
        // mitverändert und „Abbrechen" wirklich verwirft.
        //
        // Nur die Felder übernehmen, die das Backend beim Speichern auch
        // erlaubt (eventId, title, description, eventDate, image,
        // eventAddress — siehe validateUpdateEvent in ETSBackend). Die
        // normale Liste (/event/all/...) liefert ohnehin nur diese Felder.
        // Die globale Suche (/event/search/...) liefert dagegen den vollen
        // Datenbank-Datensatz inklusive `user` und `status`. Wurde ein Event
        // über die Suche geöffnet, flogen diese verbotenen Felder beim
        // Speichern mit — das Backend antwortete mit 422 „user is not
        // allowed", der Verwalter sah nur console.error und der Dialog blieb
        // stumm offen. Mit der Auswahl hier ist es egal, welche
        // zusätzlichen Felder eine Quelle mitliefert.
        const { _id, title, description, eventDate, image, eventAddress } = event;
        this.editEvent = Object.assign({}, this.editEvent, { _id, title, description, eventDate, image });
        // eventAddress ist selbst verschachtelt (eventAddress.location ist ein
        // eigenes Objekt) — ein flaches Object.assign kopiert nur die oberste
        // Ebene und this.editEvent.eventAddress hätte weiterhin auf DASSELBE
        // Objekt gezeigt wie this.events[i].eventAddress in der Tabellenzeile.
        // FOLGE (gemessen): Scheiterte das Speichern (z.B. Backend lehnt eine
        // Adresse ohne country ab), blieb die kaputte Adresse in der
        // angezeigten Tabellenzeile stehen, obwohl die Datenbank unverändert
        // war — jedes weitere Speichern scheiterte dann mit derselben
        // Meldung, bis die Seite neu geladen wurde. Deshalb hier eine echte
        // tiefe Kopie, nicht nur für eventAddressObject weiter unten.
        this.editEvent.eventAddress = JSON.parse(JSON.stringify(eventAddress));
        // WAR FALSCH: Das Datumsfeld (type="date") kennt nur den Tag. Beim
        // Speichern wurde bisher NUR eventDateObject (JJJJ-MM-TT) als
        // eventDate verschickt — das Backend interpretierte das als
        // Mitternacht und überschrieb damit die ursprüngliche Uhrzeit, selbst
        // wenn der Verwalter nur die Beschreibung geändert und das Datum gar
        // nicht angefasst hatte. FOLGE (gemessen): Aus einer Ausfahrt um
        // 17:00 Uhr wurde nach jeder Bearbeitung 00:00 Uhr. Die ursprüngliche
        // Uhrzeit wird hier gemerkt und beim Speichern wieder angehängt
        // (siehe saveEventToServer()).
        //
        // Die Trennstelle wird EINMAL bestimmt und geprüft: Fehlt das "T"
        // (indexOf liefert dann -1), ergab substring(0, -1) eine leere
        // Zeichenkette — das Datumsfeld wäre leer gewesen — und
        // substring(-1) die GANZE Zeichenkette. Beim Speichern wäre daraus
        // Tag + Tag geworden, also ein unbrauchbares Datum. Jetzt wird in
        // diesem Fall der Wert unverändert übernommen und kein Zeitanteil
        // gemerkt.
        const eventTimeSeparator = event.eventDate.indexOf("T");
        this.editEvent.eventDateObject = eventTimeSeparator > -1
          ? event.eventDate.substring(0, eventTimeSeparator)
          : event.eventDate;
        this.editEvent.eventTimePart = eventTimeSeparator > -1
          ? event.eventDate.substring(eventTimeSeparator)
          : '';

        // Für die Karte eine eigene, gedrehte Kopie der Koordinaten anlegen.
        // In der Datenbank stehen Koordinaten als [Länge, Breite] (Standard
        // für Geo-Abfragen, siehe swapCoordinates() weiter unten beim
        // Speichern). GoogleMap.vue liest coordinates[0] aber als Breite und
        // coordinates[1] als Länge (siehe deren mounted()) — ungedreht
        // landete die Karte beim Öffnen eines bestehenden Events an der
        // falschen Stelle auf der Erde (aus 51,9° Nord/13,9° Ost wurde
        // 13,9° Nord/51,9° Ost, Indischer Ozean vor Somalia statt Lübben).
        // Gleiches Vorgehen wie openEditTrip() in Trips.vue beim Laden.
        //
        // WICHTIG: eine eigene Kopie, keine Referenz auf eventAddress.
        // Object.assign kopiert nur die oberste Ebene — ohne die Kopie
        // hätte das Drehen für die Karte auch eventAddress.location.coordinates
        // selbst verändert (gleiche Referenz). Ein zweites Speichern ohne
        // Adressänderung hätte dann die bereits gedrehten Werte nicht noch
        // einmal gedreht und falsche Koordinaten in die Datenbank
        // geschrieben.
        this.editEvent.eventAddressObject = Object.assign({}, event.eventAddress, {
          location: Object.assign({}, event.eventAddress.location, {
            coordinates: this.swapCoordinates(event.eventAddress.location.coordinates),
          }),
        });
      }
      this.editEvent.editType = type;

      this.editDialog = true;
    },
    openDeleteEvent(event) {
      this.deleteDialog = true;
      this.editEvent = event;
    },
    deleteEvent() {
      let _this = this;
      this.$axios
        .delete('/event/delete/' + this.editEvent._id)
        .then(function (response) {
          console.log(response.data);
            // WAR FALSCH: Hier wurde nur ausgewertet, DASS eine Antwort kam.
            // Dieses Backend schickt einen fachlichen Fehlschlag aber mit
            // Statuscode 200 und meldet ihn nur im Feld "success" (z.B.
            // "Nicht gefunden", wenn die Veranstaltung inzwischen weg ist,
            // oder "Nicht erlaubt" bei fehlender Berechtigung). FOLGE
            // (gemessen): Der Verwalter klickte auf den Papierkorb, der
            // Dialog schloss sich, die Liste lud neu — und die Veranstaltung
            // stand noch da, ohne jede Meldung. Er hielt es für einen
            // Klickfehler und versuchte es erneut. Gleiches Muster und
            // gleicher Fix wie in Posts.vue und Trips.vue.
            if (response.data && response.data.success === false) {
              console.error(response.data.message);
              _this.$showCommonError();
              return;
            }
            _this.deleteDialog = false;
            // Die Liste wurde nach dem Löschen nicht neu geholt — die gelöschte
            // Veranstaltung stand bis zum nächsten Seitenwechsel weiter in der
            // Tabelle und ließ sich erneut zum Löschen anklicken.
            _this.fetchEvents();
        })
        .catch(function (error) {
          console.error(error);
          // Ohne diese Zeile blieb auch ein echter Netz-/Serverfehler für den
          // Verwalter unsichtbar — er sah nur, dass nichts passierte.
          _this.$showCommonError();
        });
    },
    saveEvent() {
      let _this = this;
      this.emptyValidation = true;
      this.$forceUpdate();


      Vue.nextTick(() => {
        if(document.getElementsByClassName('is-invalid').length > 0) {
          this.emptyDialog = true;
          return;
        }
        _this.saveEventToServer();
      });
    },
    saveEventToServer() {
      let _this = this;
      const eventToSave = Object.assign({}, this.editEvent);
      eventToSave.eventDate = eventToSave.eventDateObject;
      // Die vom Datumsfeld gelieferte Zeichenkette enthält nur den Tag. Beim
      // Bearbeiten die zuvor gemerkte Uhrzeit (siehe openEditEvent()) wieder
      // anhängen, damit sie nicht stillschweigend auf Mitternacht springt.
      if (eventToSave.editType == 'edit' && eventToSave.eventTimePart) {
        eventToSave.eventDate = eventToSave.eventDateObject + eventToSave.eventTimePart;
      }
      // Der Adressübertrag stand bisher NUR im Zweig 'new' — beim Bearbeiten
      // wurde eine neu gewählte Adresse nie in eventToSave.eventAddress
      // übernommen. Der Verwalter änderte den Standort, bekam „Erfolg"
      // gemeldet, gespeichert wurde aber weiter die alte Adresse.
      //
      // Die Bedingung prüft jetzt eventAddressObject.coordinates statt nur
      // editType == 'new': GoogleMap.vue liefert bei einer Auswahl über die
      // Karte ein FLACHES Objekt (type/coordinates direkt am Objekt, siehe
      // getFormattedAddress in widget/GoogleMap.vue). Beim Bearbeiten ohne
      // Kartenauswahl steht in eventAddressObject dagegen unverändert der
      // Datensatz vom Server mit VERSCHACHTELTEM .location — dort gibt es
      // kein eventAddressObject.coordinates. Die Prüfung lässt eine
      // bestehende, nicht angefasste Adresse deshalb unangetastet, statt sie
      // mit undefined zu überschreiben.
      if (eventToSave.eventAddressObject && eventToSave.eventAddressObject.coordinates) {
        eventToSave.eventAddress.city = eventToSave.eventAddressObject.city;
        eventToSave.eventAddress.place = eventToSave.eventAddressObject.place;
        eventToSave.eventAddress.country = eventToSave.eventAddressObject.country;
        eventToSave.eventAddress.state = eventToSave.eventAddressObject.state;
        eventToSave.eventAddress.location.type = eventToSave.eventAddressObject.type;
        // GoogleMap liefert [Breite, Länge] (getFormattedAddress: lat(), lng()).
        // Das Backend braucht beim Speichern [Länge, Breite] — eventController.js
        // und der 2dsphere-Index in ETSBackend/models/Event.js erwarten
        // coordinates: [longitude, latitude]. Ohne das Drehen tauchte eine
        // Veranstaltung in der Umkreissuche der App nie auf. Gleiches
        // Vorgehen wie swapCoordinates() in Trips.vue.
        eventToSave.eventAddress.location.coordinates = this.swapCoordinates(eventToSave.eventAddressObject.coordinates);
      }


      delete eventToSave.eventAddressObject;
      delete eventToSave.eventDateObject;
      delete eventToSave.eventTimePart;
      delete eventToSave.editType;
      if(this.editEvent.editType == 'edit') {
        eventToSave.eventId = eventToSave._id;
      }
      var fileToUpload = null;
      if(document.getElementById('imageFile').files.length > 0 ) {
        if(((document.getElementById('imageFile').files[0].size/1024)/1024).toFixed(4) > 20) {
          this.$showErrorFileSize(20);
          return;
        }
        fileToUpload = document.getElementById('imageFile').files[0];

        delete eventToSave.image;
      }
      delete eventToSave._id;

      const body = this.$formatUrlEncoded(eventToSave, fileToUpload);
      if(this.editEvent.editType == 'new') {
        this.$axios.post('/event/add', body).then(function(response){
            console.log(response.data);
            // HTTP 200 heisst hier nicht Erfolg: helpers/response.js im
            // Backend antwortet auch bei fachlichem Fehlschlag (z.B. eine
            // Adresse ohne country) mit Statuscode 200 und schreibt das
            // Ergebnis nur in `success`/`message`. Ohne diese Prüfung lief
            // der Code hier weiter, der Dialog schloss sich und der
            // Verwalter sah "Erfolg", obwohl nichts gespeichert wurde.
            if (response.data && response.data.success === false) {
              console.error(response.data.message);
              _this.$showCommonError();
              return;
            }
            _this.editDialog = false;
            _this.fetchEvents();
          }).catch(function(error){
            // Bisher landete ein Speicherfehler NUR in console.error — der
            // Dialog blieb einfach offen, ohne dass der Verwalter etwas
            // davon sah (z.B. bei einem vom Backend abgelehnten Feld).
            // Jetzt zusätzlich sichtbar melden, unabhängig von der Ursache.
            console.error(error);
            _this.$showCommonError();
          });
      } else {
        this.$axios.put('/event/update', body).then(function(response){
            // Gleicher Fall wie oben bei /event/add: HTTP 200 mit
            // success:false ist ein fachlicher Fehlschlag, kein Erfolg.
            if (response.data && response.data.success === false) {
              console.error(response.data.message);
              _this.$showCommonError();
              return;
            }
            _this.editDialog = false;
            _this.fetchEvents();
          }).catch(function(error){
            console.error(error);
            _this.$showCommonError();
          });
      }
    },
    initializeEvent() {
      this.editEvent = {
        _id: "",
        description: "",
        eventAddressObject: {},
        eventAddress: {
          city: "",
          country: "",
          place: "",
          state: "",
          location: {
            type: "",
            coordinates: "",
          },
        },
        eventDate: "",
        image: "",
        title: "",
        eventDateObject: null,
        editType: "",
      };
      this.updatedPic = '';
    },
    checkFileInput() {
      if(document.getElementById('imageFile').files.length == 0) {
        return true;
      }
      return false;
    },
    setFileName() {
       let path = document.getElementById('imageFile').value;
       if(path) {
         var startIndex = path.lastIndexOf("\\");
         document.getElementById('imageFileDisplay').value = path.substring(startIndex + 1);
         this.updatedPic = URL.createObjectURL(document.getElementById('imageFile').files[0]);
       } else {
         document.getElementById('imageFileDisplay').value = '';
       }
  },
  setTimePicker(timeSpan) {
      console.log(timeSpan);
           let currentId = 'dropdown' + this.currentTimeSpan;
           let newId = 'dropdown' + timeSpan;

           document.getElementById(currentId).classList.remove('active');
           document.getElementById(newId).classList.add('active');

           this.currentTimeSpan = timeSpan;
           this.setCurrentTimeSpan(timeSpan);
       },
    setCurrentTimeSpan(timeSpan) {
      this.currentTimeSpan = timeSpan;
      this.fetchEvents();
    },
    getCurrentTimeSpan() {
      let time = -1;
      if(this.currentTimeSpan == 'Today') {
          time = 1;
      } else if (this.currentTimeSpan == 'LastWeek') {
          time = 7;
      } else if (this.currentTimeSpan == 'LastMonth') {
          time = 30;
      } else if (this.currentTimeSpan == 'AllTime') {
          time = -1;
      }

      return time;
    }
  },

  name: "App",
  components: {
    GoogleMap,
  },
};
</script>

<style scoped>
.v-dialog > .v-card > .v-card__actions {
  padding: 8px 16px;
}
</style>

